import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-row",
  "use": "icon-row-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-row\"><path d=\"M222.830565 208.372093h577.488372v85.049834H222.830565z\" fill=\"#currentColor\" p-id=\"20163\" /><path d=\"M474.578073 258.551495h85.049834v557.076412h-85.049834z\" fill=\"#currentColor\" p-id=\"20164\" /><path d=\"M1022.299003 1022.299003h-1020.598006v-1020.598006h1020.598006z m-935.548172-85.049834h850.498338v-850.498338h-850.498338z\" fill=\"#currentColor\" p-id=\"20165\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol